import { Action, createReducer, on } from '@ngrx/store';
import {
  enrollMileagePlanMember,
  enrollMileagePlanMemberFailure,
  enrollMileagePlanMemberSuccess,
  resetMileagePlanEnrollmentResult,
  setMileagePlanEnrollmentRequest,
} from './mileage-plan-enrollment-service.actions';
import { initialMileagePlanEnrollmentServiceState } from './mileage-plan-enrollment-service.state';
import { Status } from '../../../models/status';
import { MileagePlanEnrollmentResult } from '../../../dtos/response/mileage-plan-response/mileage-plan-enrollment-result';

const featureReducer = createReducer(
  initialMileagePlanEnrollmentServiceState,
  on(enrollMileagePlanMember, (state, { mileagePlanEnrollmentRequest }) => ({
    ...state,
    mileagePlanEnrollmentStatus: Status.LOADING,
  })),
  on(enrollMileagePlanMemberSuccess, (state, { mileagePlanEnrollmentResult }) => ({
    ...state,
    mileagePlanEnrollmentStatus: Status.STABLE,
    mileagePlanEnrollmentResult,
    memberNumber: mileagePlanEnrollmentResult?.result?.mileagePlanNumber,
  })),
  on(enrollMileagePlanMemberFailure, (state, { mileagePlanEnrollmentResult }) => ({
    ...state,
    mileagePlanEnrollmentStatus: Status.FAILED,
    mileagePlanEnrollmentResult,
  })),
  on(resetMileagePlanEnrollmentResult, (state) => ({
    ...state,
    memberNumber: null as unknown as string,
    mileagePlanEnrollmentStatus: Status.STABLE,
    mileagePlanEnrollmentResult: null as unknown as MileagePlanEnrollmentResult,
  })),
  on(setMileagePlanEnrollmentRequest, (state, { mileagePlanEnrollmentRequest }) => ({
    ...state,
    mileagePlanEnrollmentRequest,
  }))
);

export function mileagePlanEnrollmentServiceReducer(state = initialMileagePlanEnrollmentServiceState, action: Action) {
  return featureReducer(state, action);
}
